/* ══════════════════════════════════════════════════════════════════════════
   Charte du portail client, d'après les maquettes validées (docs/maquettes).
   Mêmes valeurs en variables CSS dans src/index.css.
   ══════════════════════════════════════════════════════════════════════════ */

export const CHARTE = {
  ecru: '#F2E8D4',
  surface: '#FBF5E8',
  bordure: '#D9CBB0',
  separateur: '#EADFC9',
  indigo: '#0E1B33',
  orange: '#D44A0F',
  orangeClair: '#FF7A3D',
  ocre: '#C18500',
  ocreClair: '#E0A848',
  /** Ocre foncé pour tout texte sur fond clair (4,5:1 au moins) ; l'ocre reste pour les fonds de badge et le texte sur indigo. */
  ocreTexte: '#7C5600',
  vert: '#5F8C20',
  bleu: '#2A6BBF',
  gris: '#5A5245',
} as const;

export const COULEURS = {
  fond: CHARTE.ecru,
  bloc: CHARTE.surface,
  blocAlterne: '#F6EEDD',
  separateur: CHARTE.bordure,
  texte: CHARTE.indigo,
  texteSecondaire: '#3E4A63',
  texteDiscret: '#7A6A4F',
  blanc: '#FFFFFF',
  /** Action attendue du client (signer, régler). */
  action: CHARTE.orange,
  /** Livré, signé, réglé, validé. */
  succes: CHARTE.vert,
  /** Ce qui attend (en attente, à régler, en vérification). */
  attention: CHARTE.ocre,
  /** Refus, trop-perçu : l'orange de la charte. */
  erreur: CHARTE.orange,
  /** En cours. */
  info: CHARTE.bleu,
  /** États neutres (en étude, archivé, inconnu). */
  neutre: CHARTE.gris,
} as const;

export type Ton = 'action' | 'succes' | 'attention' | 'erreur' | 'info' | 'neutre';

export const COULEUR_TON: Record<Ton, string> = {
  action: COULEURS.action,
  succes: COULEURS.succes,
  attention: COULEURS.attention,
  erreur: COULEURS.erreur,
  info: COULEURS.info,
  neutre: COULEURS.neutre,
};

/** Couleur d'un texte posé sur fond clair : l'ocre passe en ocre foncé pour rester lisible. */
export function texteSurClair(hex: string): string {
  const h = hex.toUpperCase();
  return h === CHARTE.ocre || h === CHARTE.ocreClair ? CHARTE.ocreTexte : hex;
}

/** Fond teinté d'une pastille, comme sur les maquettes (10 % pour le bleu, 12 % sinon). */
export function fondTeinte(hex: string): string {
  const h = hex.replace('#', '');
  if (h.length !== 6) return 'transparent';
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const alpha = hex.toUpperCase() === CHARTE.bleu ? 0.10 : 0.12;
  return `rgba(${r},${g},${b},${alpha})`;
}
